/**
 * Decodes a string where only forward slashes were encoded as %2F
 */
export const decodeSlashes = (str: string): string => {
  return str.replace(/%2F/gi, '/');
};

/**
 * Formats a customer name for display
 * Now ensures slash decoding happens first before any formatting
 */
export const formatCustomerName = (name: string): string => {
  // First, decode any potential encoded slashes
  const decodedName = decodeSlashes(name);
  
  const parts = decodedName.split('-');
  return parts
    .map(part => part.trim())
    .filter(part => part.length > 0)
    .map(part => {
      let punctuation = '';
      let processedPart = part;
      
      // Check for and remove trailing punctuation
      if (processedPart.endsWith(',') || processedPart.endsWith('.')) {
        punctuation = processedPart.slice(-1);
        processedPart = processedPart.slice(0, -1);
      }

      // Split into words and capitalize each word
      const words = processedPart.split(' ');
      return words
        .map(word => {
          const trimmed = word.toLowerCase();
          // Check if word should be fully capitalized
          if (word.length <= 3 && !['oil', 'gas', 'inc', 'tap'].includes(trimmed)) {
            return word.toUpperCase();
          }
          // Otherwise capitalize first letter of each word
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ') + punctuation;
    })
    .join(' ');
};